module.exports = __webpack_public_path__ + "img/close_square.36b15842.svg";